/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PerfEnergyKpiType } from '../../models/perf-energy-kpi-type';
import { PerfEnergyTimeSeries } from '../../models/perf-energy-time-series';

export interface GetPerfEnergyTimeSeriesPerStation$Params {

/**
 * The start date time of data to filter
 */
  startDateTime?: string;

/**
 * The end date time of data to filter
 */
  endDateTime?: string;

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;

/**
 * The type of KPI, we want to GET
 */
  kpiType: PerfEnergyKpiType;
}

export function getPerfEnergyTimeSeriesPerStation(http: HttpClient, rootUrl: string, params: GetPerfEnergyTimeSeriesPerStation$Params, context?: HttpContext): Observable<StrictHttpResponse<PerfEnergyTimeSeries>> {
  const rb = new RequestBuilder(rootUrl, getPerfEnergyTimeSeriesPerStation.PATH, 'get');
  if (params) {
    rb.query('startDateTime', params.startDateTime, {});
    rb.query('endDateTime', params.endDateTime, {});
    rb.path('uid', params.uid, {});
    rb.path('kpiType', params.kpiType, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PerfEnergyTimeSeries>;
    })
  );
}

getPerfEnergyTimeSeriesPerStation.PATH = '/custom/time-series/perf-energy/{kpiType}/station/{uid}';
